import React, { useState } from 'react';
import { apiClient } from '../utils/apiClient';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';
import { BRAND_NAME } from '../constants/brand';

const FirstPasswordSetup = () => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
    if (success) setSuccess('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.current_password || !formData.new_password || !formData.confirm_password) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }

    if (formData.new_password.length < 8) {
      setError('Yeni şifre en az 8 karakter olmalı.');
      return;
    }

    if (formData.new_password !== formData.confirm_password) {
      setError('Yeni şifre ve tekrar şifresi aynı olmalı.');
      return;
    }

    try {
      setSaving(true);
      const response = await apiClient.post('/auth/change-password', formData);
      login(response.data.token, response.data.user);
      setSuccess('Şifreniz güncellendi. Ana panele yönlendiriliyorsunuz...');
      setTimeout(() => navigate('/'), 600);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Şifre güncellenemedi.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-brand">
          <div className="brand-content">
            <h1>İlk Giriş Şifre Kurulumu</h1>
            <p>
              {BRAND_NAME}
              {' '}
              güvenlik politikası gereği ilk girişte geçici şifrenizi değiştirmeniz gerekir.
            </p>
            <div className="brand-features">
              <div className="feature"><span>01</span><span>Geçici şifrenizi bir daha kullanmayın</span></div>
              <div className="feature"><span>02</span><span>En az 8 karakter güçlü şifre belirleyin</span></div>
              <div className="feature"><span>03</span><span>Hesap sahibi: {user?.email || '-'}</span></div>
            </div>
          </div>
        </div>
        <div className="auth-form-section">
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-header">
              <h2>Şifreyi Değiştir</h2>
              <p>Bu adım tamamlanmadan sisteme giriş yapamazsınız.</p>
            </div>

            {error && (
              <div className="alert alert-danger">
                <span className="alert-icon">!</span>
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="alert alert-success">
                <span className="alert-icon">+</span>
                <span>{success}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="current_password">Geçici Şifre</label>
              <input
                id="current_password"
                name="current_password"
                type="password"
                value={formData.current_password}
                onChange={handleChange}
                placeholder="Yönetici tarafından verilen geçici şifre"
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="new_password">Yeni Şifre</label>
              <input
                id="new_password"
                name="new_password"
                type="password"
                value={formData.new_password}
                onChange={handleChange}
                placeholder="En az 8 karakter"
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirm_password">Yeni Şifre (Tekrar)</label>
              <input
                id="confirm_password"
                name="confirm_password"
                type="password"
                value={formData.confirm_password}
                onChange={handleChange}
                placeholder="Yeni şifreyi tekrar girin"
                disabled={saving}
              />
            </div>

            <button type="submit" className="btn-submit" disabled={saving}>
              {saving ? 'Kaydediliyor...' : 'Şifreyi Kaydet ve Devam Et'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FirstPasswordSetup;
